// extracted by mini-css-extract-plugin
module.exports = {"attachments":"style_attachments__1ImPY","center":"style_center__3hY_W"};